import useSWRMutation, { MutationFetcher } from 'swr/mutation'

import { apiPostFetcher } from '@/common/api/fetcher'
import { useShowToastIfMutationError } from '@/common/app/toast'

export interface MutationOptions<R> {
  onSuccess?: (response: R) => void
  onError?: (error: Response) => void
  errorNotShown?: boolean
}

interface Params {
  [index: string]: any
}

export const useCallMutation = <R extends Params, V extends Params>(
  path: string,
  options?: MutationOptions<R>,
  fetcher?: MutationFetcher<R, string, V>
) => {
  const showError = useShowToastIfMutationError()

  return useSWRMutation<R, Response, string, V>(path, fetcher ?? apiPostFetcher, {
    onSuccess: (response) => {
      options && options.onSuccess && options.onSuccess(response)
    },
    onError: (error) => {
      options && options.onError && options.onError(error)
      !options?.errorNotShown && showError(error)
    }
  })
}
